// extracted by mini-css-extract-plugin
export default {"pageTitle":"client-edit-page_pageTitle__z76j0"};